import { Component, input } from '@angular/core';
import {
  ReleaseNoteCategory,
  ReleaseNoteCategoryDisplay,
} from 'src/app/_models/release-note-categories';

@Component({
    selector: 'app-category',
    imports: [],
    templateUrl: './category.component.html',
    styleUrl: './category.component.scss'
})
export class CategoryComponent {
  /** Release note category display */
  ReleaseNoteCategoryDisplay = ReleaseNoteCategoryDisplay;

  /** Release note category (required) */
  category = input<ReleaseNoteCategory>();

  public get classes(): string {
    return `category-chip--${this.category().toString()}`;
  }
}
